module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl1-50.51f96b28.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl1-50.png
// module id = 3355
// module chunks = 11